import { Comune } from './comune';
import { Trascodifica } from './trascodifica';
import { EfficienzaEnergetica } from './efficienza-energetica';
import { Profilo } from './profilo';
import { Cap } from './cap';
import { DocumentoImmobile } from './documento-immobile';
import { DatoCatastale } from './dato-catastale';
import { VideoImmobile } from './video-immobile';

export class Immobile {
	dataCreazione: Date;
	id: number;
	protezioneCanoneAffitto: boolean;
	numeroLocali: number;
	numeroLocaliMax: number;
	numeroBagni: number;
	numeroBagniMax: number;
	superficie: number;
	superficieMax: number;
	prezzo: number;
	prezzoRibasso: number;
	dataDisponibilita: Date;
	piano: string;
	numeroPiani: number;
	descrizione: string;
	comune: Comune;
	indirizzo: string;
	efficienzaEnergetica: EfficienzaEnergetica;
	profilo: Profilo;
	idServizi: number[];
	nomeFoto: string[];
	nomeDocumenti: string[];
	documenti: DocumentoImmobile[];
	autorizzazioneBlocco: boolean;
	tipologiaAnnuncio: Trascodifica;
	idTipologiaAnnuncio: number;
	cap: Cap;
	idCategoria: number;
	categoria: Trascodifica;
	tipologiaImmobile: Trascodifica;
	idTipologiaImmobile: number;
	disponibilita: Trascodifica;
	idDisponibilita: number;
	tipologiaProprieta: Trascodifica;
	idTipologiaProprieta: number;
	riferimento: number;
	affittoConRiscatto: boolean;
	ascensore: boolean;
	idCucina: number;
	cucina: Trascodifica;
	idBox: number;
	box: Trascodifica;
	idInfisso: number;
	infisso: Trascodifica;
	portaBlindata: boolean;
	impiantoAllarme: boolean;
	cancelloElettrico: boolean;
	videocitofono: boolean;
	portineria: boolean;
	giardino: boolean;
	arredamento: boolean;
	speseCondominialiAnnue: number;
	speseRiscaldamentoAnnue: number;
	bloccato: boolean;
	visibileAgenzia: boolean;
	my: boolean;
	speseRiscaldamentoAnnueAssenti: boolean;
	speseCondominialiAnnueAssenti: boolean;
	datiCatastali: Array<DatoCatastale>;
	errors: Array<String>;
	balcone: boolean; 
	terrazzo: boolean;
	preferito: boolean;
	stato:Trascodifica;
	video: Array<VideoImmobile>;
	urlTourVirtuale: string;

	constructor() {
		this.comune = new Comune();
		this.cap = new Cap();
		this.efficienzaEnergetica = new EfficienzaEnergetica();
		this.tipologiaAnnuncio = new Trascodifica();
		this.tipologiaImmobile = new Trascodifica();
		this.disponibilita = new Trascodifica();
		this.tipologiaProprieta = new Trascodifica();
		this.idServizi = [];
		this.affittoConRiscatto = false;
		this.ascensore = false;
		this.portaBlindata = false;
		this.impiantoAllarme = false;
		this.cancelloElettrico = false;
		this.videocitofono = false;
		this.portineria = false;
		this.giardino = false;
		this.arredamento = false;
		this.visibileAgenzia = false;
		this.balcone = false;
		this.terrazzo = false;
		this.protezioneCanoneAffitto = false;
		this.datiCatastali = [new DatoCatastale()];
		this.video = new Array<VideoImmobile>();
		this.video[0] = new VideoImmobile();
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/immobile.ts